import { useDispatch } from 'react-redux'
import { navigateToExternalUrl } from '../store/history/historySlice'
import { attemptDeepLinking } from './deepLinking'
import { isAndroid } from '../domain/Device'
import { APPLE_STORE_URL, PLAY_STORE_URL } from '../parameters'

export const useDeepLinking = (appUrl: string) => {
  const storeUrl = isAndroid() ? PLAY_STORE_URL : APPLE_STORE_URL

  const dispatch = useDispatch()

  return () =>
    attemptDeepLinking({
      onNavigateToApp: () => {
        dispatch(navigateToExternalUrl({ url: appUrl }))
      },
      onNavigateToStore: () => {
        dispatch(navigateToExternalUrl({ url: storeUrl }))
      },
    })
}
